import { React, useState, useEffect } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../../dashboard/dashboard.styled";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import { InformationsWrapper } from "../../customer/customersPage.styled";
import FormAccordion from "../../../components/Form/FormAccordion";
import { SelectField, InputField } from "../../../components/Form/FormComponents";
import { Formgroup, ButtonGroup, Button } from "../../Products/Forms/ProductForm.styled";
import { AiOutlineSave } from "react-icons/ai";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import { createAdmin, getDepartments, getPrivileges } from "../utils";
import { useNavigate } from "react-router";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";

function AddUser() {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({});
	const [error, setError] = useState(null);
	const [passwordError, setPasswordError] = useState(null);
	// const [bvnError, setBvnError] = useState(null);
	//const [accountName, setAccountName] = useState(null); //this is the name gotten from the bvn verification
	const [value, setValue] = useState();
	const [departmentOptions, setDepartmentOptions] = useState([]);
	const [privilegeOptions, setPrivilegeOptions] = useState([]);
	// const [isFinance, setIsFinance] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		setDepartmentData();
	}, []);
	useEffect(() => {
		emailValidations();
		passwordValidation();
		// showBvn();
	}, [formData]);

	const setDepartmentData = async () => {
		try {
			const data = await getDepartments();
			if (data?.result) {
				// console.log(data.result);
				setDepartmentOptions(data.result);
			} else {
				setDepartmentOptions([]);
			}
		} catch (error) {
			toast.error("unable to fetch department data, please try again later");
		}
	};

	const setPrivileges = async (id) => {
		try {
			const data = await getPrivileges(id);
			// console.log(data);
			if (data?.result) {
				// console.log(data.result);
				setPrivilegeOptions(data?.result?.roles);
			} else {
				setPrivilegeOptions([]);
			}
		} catch (error) {
			toast.error("unable to fetch department privileges, please try again later");
		}
	};

	const handleDepartment = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		const selectedDepartment = e.target.value;

		//find object of selected department from array of departments
		const selectedDepartmentObject = departmentOptions.find((item) => item.department === selectedDepartment);
		setPrivileges(selectedDepartmentObject?.objectId);
	};

	const emailValidations = () => {
		if (formData.email) {
			if (!isValidEmail(formData.email)) {
				setError("please enter a valid email address");
			} else {
				setError(null);
			}
		} else {
			setError(null);
		}
	};

	const passwordValidation = () => {
		if (formData.password && validatePassword(formData.password)) {
			setPasswordError(null);
		} else if (!formData.password) {
			setPasswordError(null);
		} else {
			setPasswordError(
				"Password must contain at least eight characters, an uppercase character, lowercase character, at least one special character and a number"
			);
		}
	};

	// const checkBvn = async (bvn) => {
	// 	dispatch(setLoadingState(true));
	// 	try {
	// 		const response = await verifyBvn(bvn);
	// 		// console.log(response)
	// 		if (response.result) {
	// 			dispatch(setLoadingState(false));
	// 			toast.success(response?.result?.message);
	// 			setAccountName(response?.result?.data?.fullname);
	// 		} else {
	// 			setBvnError(null);
	// 			dispatch(setLoadingState(false));
	// 			toast.error(response.error);
	// 			setAccountName(null);
	// 		}
	// 	} catch (error) {
	// 		setBvnError(null);
	// 		dispatch(setLoadingState(false));
	// 		setAccountName(null);
	// 		toast.error("Unable to verify bvn, please try again later");
	// 	}
	// };

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
		// if (e.target.name === "bvn" && e.target.value.length < 11) {
		// 	setBvnError("BVN must be 11 digits");
		// 	setAccountName(null);
		// } else if (e.target.name === "bvn" && e.target.value.length === 11) {
		// 	setBvnError(null);
		// 	checkBvn(e.target.value);
		// }
	};
	// console.log(formData);
	const isValidEmail = (email) => {
		return /\S+@\S+\.\S+/.test(email);
	};

	const validatePassword = (password) => {
		let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
		if (password.match(check)) {
			return true;
		} else {
			return false;
		}
	};

	const submitData = () => {
		createNewAdmin();
	};

	const removePlus = (number) => {
		if (number) {
			let num = number.replace("+", "");
			return num;
		} else {
			return "";
		}
	};

	const createNewAdmin = async () => {
		console.log({ ...formData, phone: removePlus(value) });
		dispatch(setLoadingState(true));
		let requiredFields = [
			"email",
			"password",
			"role",
			"lastName",
			"firstName",
			"gender",
			"address",
			"privileges",
		];
		// if (isFinance) {
		// 	requiredFields = [
		// 		"email",
		// 		"password",
		// 		"role",
		// 		"lastName",
		// 		"firstName",
		// 		"gender",
		// 		"address",
		// 		"privileges",
		// 		"bvn",
		// 		"dob",
		// 	];
		// } else {
		// 	requiredFields = [
		// 		"email",
		// 		"password",
		// 		"role",
		// 		"lastName",
		// 		"firstName",
		// 		"gender",
		// 		"address",
		// 		"privileges",
		// 	];
		// }

		//check if any of the field is empty, if yes return as an empty field

		const emptyFields = requiredFields.filter((field) => !formData[field]);
		//all data must be filled and at least one image
		if (emptyFields.length > 0) {
			dispatch(setLoadingState(false));
			// Handle validation error
			console.log(emptyFields.join(", "));
			// console.log(ProductForm)
			toast.error("Please ensure you fill all required fields before clicking on save");
			return;
		}
		//check if bvn is valid
		// if (isFinance && !accountName) {
		// 	dispatch(setLoadingState(false));
		// 	toast.error("Please ensure you verify the bvn before clicking on save");
		// 	return;
		// }

		try {
			let data = await createAdmin({ ...formData, phone: removePlus(value) });
			if (data.result) {
				dispatch(setLoadingState(false));
				setFormData({});
				navigate("/users");
				toast.success("user successfully created");
			} else {
				dispatch(setLoadingState(false));
				console.log(data);
				toast.error(data.error);
			}
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error("Unable to create new admin, please try again later");
		}
	};

	// const showBvn = () => {
	// 	if (formData.role === "Finance" && formData.privileges === "firstLineApproval") {
	// 		setIsFinance(true);
	// 	} else {
	// 		setIsFinance(false);
	// 	}
	// };

	const InputStyles = {
		border: "1px solid #b8c8cf",
		borderRadius: "6px",
		padding: " 8px 14px",
	};

	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				<IntroductionHeader nav={true} />
				<InformationsWrapper className='mt-20'>
					<p className='avatar'>
						<img src='/images/UserAvatar_img.svg' alt='user image' />
					</p>
					<FormAccordion className='mt-4' title='User information' open={true}>
						<div className='grid grid-cols-3 gap-5'>
							<Formgroup type='users'>
								<label>Last name</label>
								<InputField
									name='lastName'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.lastName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>First name</label>
								<InputField
									name='firstName'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.firstName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Email address</label>
								<InputField
									name='email'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.email}
									type={"email"}
								/>
								{error && <p style={{ color: "red" }}>{error}</p>}
							</Formgroup>

							<Formgroup type='users'>
								<label>Password</label>
								<InputField
									name='password'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.password}
								/>
								{passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
							</Formgroup>

							<Formgroup type='users'>
								<label>Phone number</label>
								<PhoneInput
									placeholder='Enter phone number'
									value={value}
									onChange={(value) => {
										setValue(value);
									}}
									international
									name='phone'
									defaultCountry='NG'
									style={InputStyles}
									countryCallingCodeEditable={false}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Gender</label>
								<SelectField
									name='gender'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.gender}
									options={["male", "female"]}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Home address</label>
								<InputField
									name='address'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.address}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Departments</label>
								<SelectField
									name='role'
									handleChange={handleDepartment}
									isEditable={true}
									value={formData?.role}
									options={departmentOptions}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Privileges</label>
								<SelectField
									name='privileges'
									handleChange={handleInputChange}
									isEditable={true}
									value={formData?.privilege}
									options={privilegeOptions}
								/>
							</Formgroup>

							{/* {isFinance && (
								<>
									<Formgroup type='users'>
										<label>BVN</label>
										<InputField
											name='bvn'
											handleChange={handleInputChange}
											isEditable={true}
											maxLength={"11"}
											value={formData?.bvn}
											required={true}
										/>
										{bvnError && <p style={{ color: "red" }}>{bvnError}</p>}
										{accountName && <p style={{ color: "green" }}>{accountName}</p>}
									</Formgroup>

									<Formgroup type='users'>
										<label>DOB</label>
										<InputField
											name='dob'
											handleChange={handleInputChange}
											isEditable={true}
											value={formData?.dob}
											type={"date"}
											required={true}
										/>
									</Formgroup>
								</>
							)} */}
						</div>

						<ButtonGroup>
							<Button onClick={submitData} type='submit' color='#ffffff' backgroundcolor='#003A50'>
								<AiOutlineSave size={24} />
								{/* <img src={saveIcon} /> */}
								<p>Save</p>
							</Button>

							<Button
								onClick={() => navigate("/users")}
								type='button'
								backgroundcolor='#FF7878'
								color='#ffffff'>
								<ImCancelCircle size={24} />
								<p>Cancel</p>
							</Button>
						</ButtonGroup>
					</FormAccordion>
				</InformationsWrapper>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default AddUser;
